import { WaterUserActionType } from "./constants";

export const getDefaultState = () => ({
  water_user: "cities",
  scenario: 1, // 1 is Drought Contingency Plans and 2 is More Severe
  toggle_about: true, // State for the topics toggle bar (open -> true , close -> false)
  chart_selected: 0, //index of the chart selected
  cities: [], //Have a list of city names
  city_metrics: {}, // Hold selected city's metrics for charts
  city_water_available: {}, //Hold water available to selected city
  city_selected: { name: "Phoenix", city_id: 1 },
  tribes: [],
  tribe_selected: { name: "San Carlos Apache Tribe", tribe_id: 1 },
  tribal_shortage: {},
  tribe_metrics: {},
  industry_selected: { name: "Arizona Public Service", industry_id: 1 },
  industry_shortage: [],
  industry_metrics: null,
  agriculture: [],
  agriculture_metrics: {},
  agriculture_selected: {
    name: "BKW Farms",
    agriculture_id: 1,
  },
  district_water: {},
  districts: [],
  water_user_options: [],
  deliveries: {},
  delivery_districts: [],
  all_cities_water_use: {},
});

export default (state = getDefaultState(), action) => {
  switch (action.type) {
    case WaterUserActionType.TOGGLE_ABOUT:
      return toggleAbout(state, action);
    case WaterUserActionType.SET_CHART:
      return setChart(state, action);
    case WaterUserActionType.RESET_CHART:
      return resetChart(state, action);
    case WaterUserActionType.SET_ALL_CITIES:
      return setCities(state, action);
    case WaterUserActionType.SET_ALL_CITIES_WATER_USE:
      return setAllCitiesWaterUse(state, action);
    case WaterUserActionType.SET_CITY_METRICS:
      return setCityMetrics(state, action);
    case WaterUserActionType.SET_SELECTED_CITY:
      return setSelectedCity(state, action);
    case WaterUserActionType.SET_ALL_TRIBES:
      return setTribes(state, action);
    case WaterUserActionType.SET_SELECTED_TRIBE:
      return setSelectedTribe(state, action);
    case WaterUserActionType.SET_TRIBAL_SHORTAGES:
      return setTribalShortages(state, action);
    case WaterUserActionType.SET_TRIBE_METRICS:
      return setTribeMetrics(state, action);
    case WaterUserActionType.SET_INDUSTRY_SHORTAGES:
      return setIndustryShortages(state, action);
    case WaterUserActionType.SET_ALL_AGRICULTURE:
      return setAgriculture(state, action);
    case WaterUserActionType.SET_AGRICULTURE_METRICS:
      return setAgricultureMetrics(state, action);
    case WaterUserActionType.SET_SELECTED_AGRICULTURE:
      return setSelectedAgriculture(state, action);
    case WaterUserActionType.SET_DISTRICT_WATER:
      return setDistrictWater(state, action);
    case WaterUserActionType.SET_WATER_USER_OPTIONS:
      return setWaterUserOptions(state, action);
    case WaterUserActionType.SET_WATER_USER:
      return setWaterUserType(state, action);
    case WaterUserActionType.SET_DELIVERIES:
      return setDeliveries(state, action);
    case WaterUserActionType.RESET_SELECTED_AGRICULTURE:
      return resetSelectedAgriculture(state, action);
    case WaterUserActionType.RESET_SELECTED_TRIBE:
      return resetSelectedTribe(state, action);
    case WaterUserActionType.RESET_SELECTED_CITY:
      return resetSelectedCity(state, action);
    case WaterUserActionType.SET_CITY_WATER_AVAILABILITY:
      return setCityWaterAvailable(state, action);
    case WaterUserActionType.SET_SCENARIO:
      return setScenario(state, action);
    case WaterUserActionType.SET_INDUSTRY_METRICS:
      return setIndustryMetrics(state, action);
    case WaterUserActionType.SET_SELECTED_INDUSTRY:
      return setSelectedIndustry(state, action);
    case WaterUserActionType.RESET_SELECTED_INDUSTRY:
      return resetSelectedIndustry(state, action);
    default:
      return state;
  }
};

const resetSelectedAgriculture = (state) => {
  return {
    ...state,
    agriculture_selected: {
      name: "BKW Farms",
      agriculture_id: 1,
    },
  };
};

const setCityWaterAvailable = (state, { city_water_data }) => {
  return {
    ...state,
    city_water_available: city_water_data,
  };
};

const setScenario = (state, { scenario }) => {
  return {
    ...state,
    scenario,
  };
};

const resetSelectedTribe = (state) => {
  return {
    ...state,
    tribe_selected: { name: "San Carlos Apache Tribe", tribe_id: 1 },
  };
};

const resetSelectedCity = (state) => {
  return {
    ...state,
    city_selected: { name: "Phoenix", city_id: 1 },
  };
};
const toggleAbout = (state) => {
  return {
    ...state,
    toggle_about: !state.toggle_about,
  };
};
const setChart = (state, { chart_index }) => {
  return {
    ...state,
    chart_selected: chart_index,
  };
};

const resetChart = (state) => {
  return {
    ...state,
    chart_selected: 0,
  };
};

const setCities = (state, { cities }) => {
  return {
    ...state,
    cities,
  };
};

const setAllCitiesWaterUse = (state, { all_cities_water_use }) => {
  return {
    ...state,
    all_cities_water_use,
  };
};

const setCityMetrics = (state, { city_metrics }) => {
  return {
    ...state,
    city_metrics,
  };
};

const setSelectedCity = (state, { city_selected }) => {
  return {
    ...state,
    city_selected: { name: city_selected.label, city_id: city_selected.value },
  };
};

const setTribes = (state, { tribes }) => {
  return {
    ...state,
    tribes,
  };
};

const setSelectedTribe = (state, { tribe_selected }) => {
  return {
    ...state,
    tribe_selected: {
      name: tribe_selected.label,
      tribe_id: tribe_selected.value,
    },
  };
};

const setTribalShortages = (state, { tribal_shortage }) => {
  return {
    ...state,
    tribal_shortage,
  };
};

const setTribeMetrics = (state, { tribe_metrics }) => {
  return {
    ...state,
    tribe_metrics,
  };
};

const setIndustryShortages = (state, { industry_shortage }) => {
  return {
    ...state,
    industry_shortage,
  };
};

const setAgriculture = (state, { agriculture }) => {
  return {
    ...state,
    agriculture,
  };
};

const setAgricultureMetrics = (state, { agriculture_metrics }) => {
  return {
    ...state,
    agriculture_metrics,
  };
};

const setSelectedAgriculture = (state, { agriculture_selected }) => {
  return {
    ...state,
    agriculture_selected: {
      name: agriculture_selected.label,
      agriculture_id: agriculture_selected.value,
    },
  };
};

const setDistrictWater = (state, { district_water }) => {
  let districts = [];
  Object.keys(district_water).map((district, idx) => {
    districts.push({ label: district, value: idx + 1 });
    return district
  });
  return {
    ...state,
    district_water,
    districts,
  };
};

const setWaterUserOptions = (state, { water_user_options }) => {
  return {
    ...state,
    water_user_options,
  };
};

const setWaterUserType = (state, { water_user }) => {
  return {
    ...state,
    water_user,
  };
};

const setDeliveries = (state, { deliveries }) => {
  let delivery_districts = [];
  Object.keys(deliveries).map((delivery, idx) => {
    delivery_districts.push({ label: delivery, value: idx + 1 });
    return delivery
  });
  return {
    ...state,
    deliveries,
    delivery_districts,
  };
};

const setIndustryMetrics = (state, { industry_metrics }) => {
  return {
    ...state,
    industry_metrics,
  };
};

const setSelectedIndustry = (state, { industry_selected }) => {
  return {
    ...state,
    industry_selected: {
      name: industry_selected.label,
      industry_id: industry_selected.value,
    },
  };
};

const resetSelectedIndustry = (state) => {
  return {
    ...state,
    industry_selected: {
      name: "Arizona Public Service",
      industry_id: 1,
    },
  };
};
